module.exports = __webpack_public_path__ + "img/send-msg-orange.220bf362.svg";